import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../../components/Common/Index.style'
import Page from '../../../../components/Page/Page'
import PageHeader from '../../../../components/PageHeader/PageHeader'
import Content from '../../../../components/Content/Content'
import SectionTitle from '../../../../components/SectioinTitle'
import BackBtn from '../../../../components/Common/BackBtn'
import BreadCrumb from '../../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = 'たった一人のあなたです　たった一つの命です | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="" />
      <SectionTitle sectionTitle="たった一人のあなたです　たった一つの命です" />
      <Content css={style.content}>
        <BreadCrumb
          lists={[
            {
              name: "HOME",
              path: "/"
            },
            {
              name: "2023秋号 No.164 目次",
              path: "/no164"
            },
            {
              name: "たった一人のあなたです　たった一つの命です"
            }
          ]}
        />
        <img
          src={`${basePath}/no164/img/4-11.png`}
          alt="新潟県こころの相談ダイヤル"
          css={style.img(250)}
        />
        
        <p>自殺の原因は人によって様々。<br />気づいてください。<br />あなたのそばの、その人に。</p>
        <p><span css={[style.emphasisColor, style.emphasisWeight]}>気づこう。</span></p>
        <p><span css={[style.emphasisColor, style.emphasisWeight]}>～あなたのアクションがいのちを救う～</span></p>
        
        <p css={style.catchTxt}>新潟県こころの相談ダイヤル</p>
        <p><span css={style.emphasisWeight}><a href="tel:0570-783-025">0570-783-025</a></span>（ナビダイヤル&emsp;なやみ なし にいがた）</p>
        
        <p>受付時間24時間</p>
        
        <p><span css={[style.emphasisColor, style.emphasisWeight]}>ひとりで悩んでいないで相談してみませんか</span></p>
        
        
        <p>詳しくは
          <a
            href="https://www.pref.niigata.lg.jp/sec/shougaifukushi/kokoronosoudan.html"
            target="_blank"
            rel="noreferrer"
          >
            <span>こちら</span>
          </a>
        </p>
        
        <BackBtn href={"/no164"} />
      </Content>
    </Page>
  )
}
export default Home
